import {
  CONTACTS_ROUTE, GAME_MAIN_ROUTES,
  GAMES_ROUTE, GAMES_ROUTES,
  INDEX_ROUTE
} from "./utils/consts";
import IndexPage from "./pages/IndexPage";
import GamesPage from "./pages/GamesPage";
import ContactsPage from "./pages/ContactsPage";
import GamePage from "./pages/GamePage";
export const publicRoutes = [
  {path: INDEX_ROUTE, Component: IndexPage, name: "Главная"},
  {path: GAMES_ROUTE, Component: GamesPage, name: "Игры"},
  {path: GAMES_ROUTES, Component: GamePage, name: "Игры"},
  {path: GAME_MAIN_ROUTES, Component: GamePage, name: "Игры"},
  {path: CONTACTS_ROUTE, Component: ContactsPage, name: "Обратная связь"},
];